import type { Control, ILaneConfig, StoreControl } from 'commons';
import type { SeriesOption } from 'echarts';

export class UpdateControl {
  static readonly type = '[SensorTable] update control';
  constructor(public control: Control) {}
}
export class AddControlToCurrentView {
  static readonly type = '[MultiView] Add Control To Sensor Table';
  constructor(
    public control: Control,
    public lane?: ILaneConfig,
    public view?: string
  ) {}
}

export class AddBatchControlsToCurrentView {
  static readonly type = '[MultiView] Add Batch Controls To Sensor Table';
  constructor(
    public controls: Control[],
    public lane?: ILaneConfig,
    public view?: string
  ) {}
}

export class RemoveControlFromCurrentView {
  static readonly type = '[MultiView] Remove Control From Sensor Table';
  constructor(public control: Control) {}
}
export class ToggleConfidence {
  static readonly type = '[SensorTable] toggleConfidence]';
  constructor(
    public readonly control: Control | StoreControl,
    public readonly value?: boolean
  ) {}
}
export class OverrideEchartsOptionOnControl {
  static readonly type = '[FileName] setEchartsControlSettings]';
  constructor(
    public readonly controlId: string,
    public readonly opts: SeriesOption
  ) {}
}
export class ToggleSensorVisibility {
  static readonly type = '[SensorTable] toggle Sensor visibility';
  constructor(public readonly control: Control | StoreControl) {}
}
export class CreateVirtualChannel {
  static readonly type = '[SensorTable] create a Virtual-Channel';
  constructor(public readonly control: Control | StoreControl) {}
}
export class BatchChangeChannels {
  static readonly type = '[SensorTable] change channels';
  constructor(
    public readonly control: Partial<Control>,
    public readonly changeSetIds?: string[]
  ) {}
}
